import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import Button from 'dpl/common/design_system/Button';
import MiniOverlayModal from 'dpl/common/mini_overlay_modal/components/MiniOverlayModal';
import { RESULTS_TYPE } from 'dpl/constants/query_params';
import { RESULTS_TYPES } from 'dpl/puppy_search_results/utils/constants';
import useAnalyticsContext from 'dpl/puppy_search_results/hooks/useAnalyticsContext';

import SearchFilters from './SearchFilters';
import useSearchFiltering from '../hooks/useSearchFiltering';

const IS_BOT_UA = window.__DPL_BOT_UA;

export default function FiltersModal({
  isMenuOpen,
  setIsMenuOpen,
  totalItemCount
}) {
  const queryParams = useSelector(state => state.queryParams);
  const { hasFilters, clearFilters } = useSearchFiltering();
  const { sendBreedSearchedAnalytics } = useAnalyticsContext();

  const initialResultType = IS_BOT_UA
    ? RESULTS_TYPES.BREEDERS
    : RESULTS_TYPES.PUPPIES;
  const resultsType = queryParams[RESULTS_TYPE] || initialResultType;

  const puppyTitle = totalItemCount === 1 ? 'puppy' : 'puppies';
  const breederTitle = totalItemCount === 1 ? 'breeder' : 'breeders';

  const itemType =
    resultsType === RESULTS_TYPES.PUPPIES ? puppyTitle : breederTitle;

  if (!isMenuOpen) return null;

  function handleApplyFilters() {
    setIsMenuOpen(false);
    sendBreedSearchedAnalytics();
  }

  return (
    <MiniOverlayModal
      className="FiltersModal"
      contentClassName="flex flex-column relative bg-white overflow-y-hidden"
      maxWidth="780px"
      zIndexClass="z-99999"
      scrollableContent
      hideCloseButton
    >
      <div className="ph12 pt12 pb8">
        <h4 className="font-32 fw-medium">Filter Results ({totalItemCount})</h4>
        <div className="absolute top-0 right-0 pv6 ph6">
          <Button
            className="br-100"
            iconName="fetch-close"
            iconSize="16px"
            size="icon"
            variant="outline"
            onClick={handleApplyFilters}
            data-test-id="mobileFiltersToggleOff"
          />
        </div>
      </div>

      <div className="flex-auto overflow-y-auto max-h-100 ph8">
        <SearchFilters />
      </div>

      <div className="flex justify-between pv2 ph12 bg-white bt b--default">
        <Button
          variant="tertiary"
          className="font-16"
          size="default"
          disabled={!hasFilters}
          onClick={clearFilters}
        >
          Clear filters
        </Button>
        <Button
          variant="primary"
          className="font-16"
          size="default"
          onClick={handleApplyFilters}
        >
          Show {totalItemCount} {itemType}
        </Button>
      </div>
    </MiniOverlayModal>
  );
}

FiltersModal.propTypes = {
  isMenuOpen: PropTypes.bool,
  setIsMenuOpen: PropTypes.func.isRequired,
  totalItemCount: PropTypes.number.isRequired
};

FiltersModal.defaultProps = {
  isMenuOpen: false
};
